export default (keys = 4) => Array.from(Array(keys).keys());
